/* eslint-disable arrow-body-style */
import TextMaxLine from 'src/components/TextMaxLine';
import { UploadMultiFile } from 'src/components/upload';
import { uploadFiles } from './sectionItemsSchemas';

export const AssetsSection = ({ assets, setValue }: { assets: string[]; setValue: any }) => {
  return (
    <>
      <TextMaxLine
        sx={{
          fontSize: '18px',
          paddingBottom: '10px',
          fontWeight: '700',
        }}
      >
        Upload Assets
      </TextMaxLine>
      <UploadMultiFile
        accept={{
          'application/pdf': [],
          'image/*': [],
          'video/*': [],
          'application/zip': [],
          'text/plain': [],//
        }}
        files={assets}
        label={'Select Or Drop Assets '}
        onDropAccepted={async (file) => {
          let response = await uploadFiles(file[0]);


          setValue('assets', [...assets, response?.url]);
        }}
        // A file attached to a lesson could never be removed (disableControl hid
        // the remove buttons and no handler was wired). Wire removal so a
        // wrong/outdated asset can be taken off the lesson.
        onRemove={(file) => setValue('assets', assets.filter((a) => a !== file))}
        onRemoveAll={() => setValue('assets', [])}
      />
    </>
  );
};
